import React, {
    useEffect, useState, useMemo, useCallback, useContext
} from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import {
    Icon, Loader, InfoLabel, DateField
} from '@jutro/components';
import { AccountBillingDetailsService } from 'gw-capability-billing';
import { UsersProfileDetailsService } from 'gw-capability-profileinfo';
import { PolicyService } from 'gw-capability-policy';
import { AMPSubmissionDraftService } from 'gw-capability-quoteandbind';
import { DocumentService } from 'gw-capability-policydocument';
import { DateRangeComponent, Link, Currency as CurrencyField } from 'gw-components-platform-react';
import { getNormalizedLOBName, isCapabilityEnabled } from 'gw-portals-config-js';
import { useAuthentication } from 'gw-digital-auth-react';
import { /* LobIconUtil,*/ LocalDateUtil } from 'gw-portals-util-js';
import { generateURL } from 'gw-portals-url-js';
import { IntlContext, TranslatorContext } from '@jutro/locale';
import { ButtonLink } from '@jutro/router';
import {getImageSrc} from './../../customer/utils/lobIconUtil';
import PageBannerComponent
    from '../../components/PageBannerComponent/PageBannerComponent';


// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';

import { ClaimService } from 'gw-capability-claim';
import { getFontIcon } from '../../customer/utils/lobIconUtil';
import styles from './LandingPage.module.scss';
import metadata from './LandingPage.metadata.json5';
import messages from './LandingPage.messages';


const getCellType = (rowData) => {
    const activePeriod = _.first(rowData.periods);
    const lineOfBusiness = activePeriod.lines.length > 1
        ? activePeriod.lines.map((line) => line) : _.first(activePeriod.lines);
    const icon = activePeriod.lines.length > 1 ? 'mi-unarchive' : getFontIcon(lineOfBusiness);
    return <Icon icon={icon} aria-label={lineOfBusiness} title={lineOfBusiness} key={lineOfBusiness} />;
};

const isPolicyActive = (periods) => {
    const currentRenewed = periods.length > 1;
    const activePeriod = _.first(periods);
    return new Date(activePeriod.effective).getTime() < new Date().getTime() && !currentRenewed;
};

const shouldRenewalNotificationShow = (accountPolicyData) => {
    return accountPolicyData.some((policy) => policy.periods.length > 1);
};

const getCellStatus = (rowData) => {
    if (isPolicyActive(rowData.periods)) {
        return <InfoLabel type="success" size="medium" message={messages.statusActive} />;
    }

    return <InfoLabel type="info" size="medium" message={messages.statusRenewed} />;
};

const getCellPolicy = (rowData) => {
    const activePeriod = _.first(rowData.periods);
    const periodWithIDCard = rowData.periods.find((policy) => policy.idCardPublicID);
    return (
        <Link
            className={styles.link}
            to={{
                pathname: `/account-policy-details/${activePeriod.policyId}`,
                productCode: activePeriod.lines[0],
                idCard: periodWithIDCard ? {
                    idCardSessionID: _.get(periodWithIDCard, 'idCardSessionID'),
                    idCardPublicID: _.get(periodWithIDCard, 'idCardPublicID')
                } : null
            }}
        >
            {activePeriod.policyId}
        </Link>
    );
};

const getPolicyNumber = (rowData) => {
    const activePeriod = _.first(rowData.periods);
    return (
        <span className={styles.link}>
            {activePeriod.policyId}
        </span>
    );
};

const getViewPolicyBtn = (rowData, rowIndex) => {
    const activePeriod = _.first(rowData.periods);
    const periodWithIDCard = rowData.periods.find((policy) => policy.idCardPublicID);
    const title = "Button to view policy details for policy number" + activePeriod.policyId
    return (
        <>

            <ButtonLink
                aria-label = {title}                
                id={`viewPolicy_${rowIndex}`}
                // className={styles.eyButtonCard}
                to={{
                    pathname: `/account-policy-details/${activePeriod.policyId}`,
                    productCode: activePeriod.lines[0],
                    idCard: periodWithIDCard ? {
                        idCardSessionID: _.get(periodWithIDCard, 'idCardSessionID'),
                        idCardPublicID: _.get(periodWithIDCard, 'idCardPublicID')
                    } : null
                }}
            >
                View Details
            </ButtonLink>
            <br />
        </>
    );
};

const getCellEffective = (rowData, rowIndex) => {
    const activePeriod = _.first(rowData.periods);
    return (
        <DateRangeComponent
            id={`effectiveDate_${rowIndex}`}
            value={activePeriod}
            fromDate="effective"
            toDate="expiration"
            hideLabel
        />
    );
};

const getPolicyEffectiveDate = (rowData, rowIndex) => {
    const activePeriod = _.first(rowData.periods);
    return (
        <DateField
            id={`effectiveDate_${rowIndex}`}
            value={activePeriod.effective}
            format="short"
            dataType={_.isString(activePeriod.effective) ? 'string' : 'object'}
            readOnly
            hideLabel
            layout="full-width"
            showOptional={false}
        />
    );
};

const getPolicyExpiryDate = (rowData, rowIndex) => {
    const activePeriod = _.first(rowData.periods);
    return (
        <DateField
            id={`effectiveDate_${rowIndex}`}
            value={activePeriod.expiration}
            format="short"
            dataType={_.isString(activePeriod.expiration) ? 'string' : 'object'}
            readOnly
            hideLabel
            layout="full-width"
            showOptional={false}
        />
    );
};

const getCellClaim = (rowData) => {
    const activePeriod = _.first(rowData.periods);

    const redirectPath = {
        pathname: '/fnol-select-policy',
        state: {
            policyNumber: activePeriod.policyId,
            redirectPath: '/home',
            claimData: { lossDate: new Date() }
        }
    };
    return (
        <Link to={redirectPath} className={styles.link}>
            {messages.fileClaim}
        </Link>
    );
};

const getCellPremium = (rowData, rowIndex) => {
    const activePeriod = _.first(rowData.periods);
    return (
        <CurrencyField
            id={`premium_${rowIndex}`}
            value={activePeriod.premium}
            dataType="object"
            readOnly
            hideLabel
        />
    );
};

const getCellPolicyNumber = (rowData) => {
    return (
        <span>
            {rowData.displayName}
        </span>
    );
};

const getCellBillingPlan = (rowData) => {
    return (
        <span>
            {rowData.periodicity}
        </span>
    );
};

const getCellLastPaymentDate = (rowData, rowIndex) => {
    const invoices = rowData.invoiceSummary;
    const latestDate = new Date(Math.max(...invoices.map((e) => new Date(e.lastPaymentDate))));
    if (latestDate.toString() === 'Invalid Date') {
        return (
            <span>
                No Payments Received
            </span>
        );
    }
    return (
        <DateField
            id={`latestDate_${rowIndex}`}
            value={latestDate}
            format="short"
            dataType={_.isString(latestDate) ? 'string' : 'object'}
            readOnly
            hideLabel
            layout="full-width"
            showOptional={false}
        />
    );
};

const getCellLastPayment = (rowData, rowIndex) => {
    return (
        <CurrencyField
            id={`paidAmount_${rowIndex}`}
            value={rowData.paidAmount}
            dataType="object"
            readOnly
            hideLabel
        />
    );
};

const getCellBalanceDue = (rowData, rowIndex) => {
    return (
        <CurrencyField
            id={`dueAmount_${rowIndex}`}
            value={rowData.balance}
            dataType="object"
            readOnly
            hideLabel
        />
    );
};

const getCellBillingDetail = (rowData, rowIndex) => {
    const title = "Button to view billing details for policy number" + rowData.displayName
    return (
        <ButtonLink
            aria-label= {title}
            id={`viewBilling_${rowIndex}`}
            className={styles.link}
            to={{
                pathname: `/billing-summary/${rowData.internalId}`
            }}
        >
            Details
        </ButtonLink>
    );
};




const getCellClaimPolicyNumber = (rowData) => {
    return (
        <span>
            {rowData.policyNumber}
        </span>
    );
};

const getCellDateOfLoss = (rowData, rowIndex) => {
    return (
        <DateField
            id={`dateOfLoss_${rowIndex}`}
            value={rowData.dateOfLoss}
            format="short"
            dataType={_.isString(rowData.dateOfLoss) ? 'string' : 'object'}
            readOnly
            hideLabel
            layout="full-width"
            showOptional={false}
        />
    );
};

const getCellClaimNumber = (rowData) => {
    return (
        <span>
            {rowData.claimNumber}
        </span>
    );
};

const getCellClaimDetail = (rowData, rowIndex) => {
    const title = "Button to view claim details for claim number" + rowData.claimNumber
    if (rowData.status === 'draft') {
        const redirectPath = {
            pathname: '/fnol-select-policy',
            state: {
                claimNumber: rowData.claimNumber,
                redirectPath: '/claims',
                claimStatus: rowData.status
            }
        };
        return (
            <ButtonLink
                aria-label={title}
                id={`viewClaim_${rowIndex}`}
                className={styles.link}
                to={redirectPath}
            >
                Details
            </ButtonLink>
        );
    }
    const redirectPath = {
        pathname: `/claims/${rowData.claimNumber}`,
        state: {
            claimNumber: rowData.claimNumber,
            redirectPath: '/claims',
            claimStatus: rowData.status
        }
    };
    return (
        <ButtonLink
        aria-label={title}
            id={`viewClaim_${rowIndex}`}
            className={styles.link}
            to={redirectPath}
        >
            Details
        </ButtonLink>
    );
};


function LandingPage(props) {
    const translator = useContext(TranslatorContext);
    const [accountBillingData, setAccountBillingData] = useState([]);
    const [accountPolicyData, setAccountPolicyData] = useState([]);
    const { authHeader } = useAuthentication();
    const [accountData, setAccountData] = useState([]);
    const [billingDetailsData, setBillingDetailsData] = useState([]);
    const [isLoading, setLoadingState] = useState(false);
    const { capabilitiesConfig, showGreeting } = appConfig;
    const [claimDataTable, setClaimDataTable] = useState([]);
    const [hasBillingError, setHasBillingError] = useState(false);
    const intl = useContext(IntlContext);
    // let [policiesLobMap, setPoliciesLobMap] = useState({});
    //  const policiesLobMap = new Map();

    const processClaimsData = useCallback(
        (claimsData) => {
            if (!_.isEmpty(claimsData)) {
                let claimsArrayResult = claimsData;
                claimsArrayResult = claimsArrayResult.map((claimInfo) => {
                    const claims = {
                        policyLOBCode: claimInfo.lineOfBusinessCode,
                        claimNumber: claimInfo.claimNumber,
                        dateOfLoss: intl.formatDate(new Date(claimInfo.lossDate), { year: 'numeric', month: 'short', day: 'numeric' }),
                        status: claimInfo.claimState,
                        policyNumber: claimInfo.policyNumber
                    };
                    return claims;
                });
                return claimsArrayResult;
            }
            return [];
        },
        [intl, translator]
    );

    const getClaims = useCallback(
        (query) => {
            const claimsPromise = ClaimService.getClaimSummaries(query, {}, authHeader);
            return claimsPromise
                .then((responseData) => {
                    const data = processClaimsData(responseData.items);
                    setClaimDataTable(data);
                }).catch((e)=>{
                    console.log(e);
                })
                .finally(() => {
                    setLoadingState(false);
                });
        },
        [authHeader, processClaimsData]
    );

    const query = {
        claimStates: ['open', 'closed']
        // claimStates: ['open', 'draft', 'closed'] // Commented for deminishing the FNOL flow
    };

    // const setPoliciesLobMap1 = () => {
    //     const policiesLobMap1 = new Map();
    //     accountPolicyData.forEach((accountPolicy) => {
    //         const periods = _.first(accountPolicy.periods);
    //         const policyLines = periods.lines;
    //         if (policyLines !== null && policyLines.length > 0) {
    //             policiesLobMap1.set([periods.policyId], periods.lines);
    //         }
    //         //
    //     });
    //     return policiesLobMap1;
    // };

    const handleError = (error) => {
        console.log('Error in API', error);
    };

    const getCellProduct = (rowData) => {
        const lobCode = rowData.policyLOBCode;
        const icon = getFontIcon(lobCode);
        return <span className="iconFocus" tabindex="0"> <Icon role="img" aria-label={translator({ id: `typekey.LOBCode.${lobCode}` })} icon={icon} title={translator({ id: `typekey.LOBCode.${lobCode}` })} key={lobCode} /></span>;
    };

    useEffect(() => {                
        setLoadingState(true);
        try {
            if (isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'billing' })) {
                // PolicyService.getAccountPolicySummaries(authHeader).then(setAccountPolicyData, handleError),
                PolicyService.getUserPolicySummaries(authHeader).then(setAccountPolicyData, handleError),
                    UsersProfileDetailsService.getAccountsContactSummaries(authHeader).then(setAccountData, handleError),
                    getClaims(query);
            }
        } finally {
            setLoadingState(false);
        }

        setLoadingState(true);
        try {
            // let billingAccData = '';
            if (isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'billing' })) {
                // billingAccData = AccountBillingDetailsService.getAccountBillingSummary(authHeader);
                // eslint-disable-next-line max-len
                AccountBillingDetailsService.getUserBillingDetails_EY(authHeader).then(setBillingDetailsData, handleError);
            }
        } finally {
            setLoadingState(false);
        }

        /* OOTB code
        let billingPromise = Promise.resolve([]);
        if (isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'billing' })) {
            billingPromise = AccountBillingDetailsService.getAccountBillingSummary(authHeader);
            AccountBillingDetailsService.getAccBillingDetails(authHeader).then(setBillingDetailsData);
        }
        Promise.all([billingPromise.then(setAccountBillingData),
            PolicyService.getAccountPolicySummaries(authHeader).then(setAccountPolicyData),
            UsersProfileDetailsService.getAccountsContactSummaries(authHeader).then(setAccountData),
            getClaims(query)
        ]).finally(() =>{
            setLoadingState(false);
        });*/
        // disable re render
        // eslint-disable-next-line react-hooks/exhaustive-deps 
        document.body.classList.remove('login');       
    }, []);


    const aggregateBilling = useCallback((invoices) => {
        if (invoices.length === 0) {
            return null;
        }

        let total = 0;
        let due = new Date(invoices[0].dueDate);

        _.each(invoices, (invoice) => {
            total += invoice.amountDue.amount;
            const newDue = new Date(invoice.dueDate);
            if (newDue.getTime() < due.getTime()) {
                due = newDue;
            }
        });

        return {
            amountDue: {
                amount: total,
                currency: invoices[0].amountDue.currency
            },
            earliestDue: due
        };
    }, []);

    const getMyBalanceOverDueAndCurrentData = useCallback(
        (invoiceStatus) => {
            if (accountBillingData.activeInvoices) {
                const invoices = accountBillingData.activeInvoices;
                return aggregateBilling(
                    invoices.filter((invoice) => invoice.invoiceStatus === invoiceStatus)
                );
            }
            return null;
        },
        [accountBillingData.activeInvoices, aggregateBilling]
    );

    const getCellClaimStatus = (rowData, rowIndex, rowProperty) => {
        const titleMessage = translator(messages.claimStatus);
        const status = rowData[rowProperty.id];
        let typeStatus = 'success';
        if (status === 'draft') {
            typeStatus = 'warning';
        } else if (status === 'closed') {
            typeStatus = 'neutral';
        }
        const claimState = translator({
            id: `typekey.ClaimState.${rowData[rowProperty.id]}`,
            defaultMessage: rowData[rowProperty.id]
        })
        return (
            <InfoLabel type={typeStatus} size="small" title={titleMessage[rowProperty.id]}>
                {claimState}
            </InfoLabel>
        );
    };

    const getBalanceData = useCallback(() => {
        const overdue = getMyBalanceOverDueAndCurrentData('due');
        const current = getMyBalanceOverDueAndCurrentData('billed');
        if (overdue && current) {
            return {
                amount: current.amountDue.amount + overdue.amountDue.amount,
                currency: current.amountDue.currency
            };
        }
        if (overdue || current) {
            return (overdue || current).amountDue;
        }
        return null;
    }, [getMyBalanceOverDueAndCurrentData]);

    const readValue = useCallback(
        (id, path) => {
            if (path === 'balanceAmount') {
                return getBalanceData();
            }
            if (path === 'overDueAmount') {
                return _.get(getMyBalanceOverDueAndCurrentData('due'), 'amountDue');
            }
            if (path === 'currentAmount') {
                return _.get(getMyBalanceOverDueAndCurrentData('billed'), 'amountDue');
            }
            if (path === 'dueDate') {
                return _.get(getMyBalanceOverDueAndCurrentData('due'), 'earliestDue');
            }
            if (path === 'myCards') {
                return accountPolicyData;
            }
            return _.get(accountPolicyData, path);
        },
        [accountPolicyData, getBalanceData, getMyBalanceOverDueAndCurrentData]
    );

    const policyWithIDCard = useMemo(() => {
        let periodWithIDCard;
        accountPolicyData.some((policyData) => {
            return policyData.periods.some((period) => {
                if (period.idCardPublicID) {
                    periodWithIDCard = period;
                    return true;
                }
                return false;
            });
        });
        return periodWithIDCard;
    }, [accountPolicyData]);

    const getIDCardQuickLink = useMemo(() => {
        if (!policyWithIDCard) {
            return null;
        }
        return DocumentService.downloadPolicyDocument(
            policyWithIDCard.idCardPublicID,
            policyWithIDCard.idCardSessionID
        );
    }, [policyWithIDCard]);

    const automatedPaymentURL = useMemo(() => {
        const billingID = _.get(accountBillingData, 'manualPayPaymentGroups[0]');

        if (!billingID) {
            return undefined;
        }
        return `billing-summary/${billingID}`;
    }, [accountBillingData]);

    const firstAccountSummaryDefined = useMemo(() => {
        return accountData.length <= 1 && !_.isEmpty(accountData);
    }, [accountData]);

    const mailToTrigger = useCallback((event, email) => {
        event.preventDefault();
        window.location = `mailto:${email}`;
    }, []);

    const claimCapabilityCheck = useMemo(() => {
        return isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'fnol' });
    }, [capabilitiesConfig]);

    const onQuoteQuickLinkClick = useCallback(
        (lob) => () => {
            const accountSummary = accountData[0];
            const submission = {
                baseData: {
                    productCode: lob,
                    accountHolder: accountSummary,
                    accountNumber: accountSummary.accountNumber,
                    policyAddress: accountSummary.accountContact.primaryAddress,
                    periodStartDate: LocalDateUtil.today()
                }
            };
            AMPSubmissionDraftService.createForAccount(submission, authHeader).then(
                (savedSubmission) => {
                    const { url } = appConfig.quoteAndBuy;
                    const location = `${url}/quote-${getNormalizedLOBName(lob)}`;
                    const params = {
                        quoteID: savedSubmission.quoteID,
                        postalCode: savedSubmission.baseData.policyAddress.postalCode
                    };

                    window.location = generateURL(location, params);
                }
            );
        },
        [accountData, authHeader]
    );

    const getCellAgent = useCallback(
        (rowData) => {
            return (
                <>
                    <Link className={styles.link} onClick={(e) => mailToTrigger(e, rowData.producerContact.email)} href="/">
                        {rowData.producerContact.displayName}
                    </Link>
                    <br />
                    {rowData.producerContact.phoneNumber ? (
                        <span>
                            {translator(messages.policyDetailsTel)}
                            {rowData.producerContact.phoneNumber}
                        </span>
                    ) : (
                        ''
                    )}
                </>
            );
        },
        [mailToTrigger, translator]
    );

    const renderHeaderData = useCallback(
        (rowData) => {
            const activePeriod = _.first(rowData.periods);
            const lineOfBusiness = activePeriod.productCode;
            const icon = getFontIcon(lineOfBusiness);
            const classb = lineOfBusiness === 'BusinessOwners' ? styles.eyCPPolicyTypeIcon : styles.eyPolicyTypeIcon;

            return (
                <h3>
                    <Icon icon={icon} title={lineOfBusiness} key={lineOfBusiness} size="50px" className={classb} />
                    <span className={styles.eyCardHeaderText}>
                        {activePeriod.productDisplayName}
                    </span>
                </h3>
            );
        },
        []
    );

    const getTableOverrides = useCallback(() => {
        return {
            typeColumn: { onCell: getCellType },
            statusColumn: { onCell: getCellStatus },
            policyColumn: { onCell: getCellPolicy },
            effectiveColumn: { onCell: getCellEffective },
            premiumColumn: { onCell: getCellPremium },
            fileAClaimColumn: {
                visible: claimCapabilityCheck,
                onCell: getCellClaim
            },
            agentColumn: {
                visible: accountData.length > 1,
                onCell: getCellAgent
            }
        };
    }, [accountData, getCellAgent]);

    const generatePolicyCardOverrides = useCallback(() => {
        const overrides = accountPolicyData.map((accountPolicy, index) => {
            return {
                [`myPolicyNo${index}`]: {
                    content: getPolicyNumber(accountPolicy)
                },
                [`myPolicyStatus${index}`]: {
                    content: getCellStatus(accountPolicy)
                },
                [`myPolicyEffectiveDate${index}`]: {
                    content: getPolicyEffectiveDate(accountPolicy)
                },
                [`myPolicyExpiryDate${index}`]: {
                    content: getPolicyExpiryDate(accountPolicy)
                },
                [`viewPolicyBtn${index}`]: {
                    content: getViewPolicyBtn(accountPolicy, index)
                },
                [`policyCard${index}`]: {
                    header: renderHeaderData(accountPolicy)
                },
                [`cardHeader${index}`]:{
                    content: renderHeaderData(accountPolicy)
                }
            };
        });

        return Object.assign({}, ...overrides);
    }, [accountPolicyData]);


    const generateBillingDetailsOverrides = useCallback(() => {
        return {
            productTypeColumn: { onCell: getCellProduct },
            policyNumberColumn: { onCell: getCellPolicyNumber },
            billingPlanColumn: { onCell: getCellBillingPlan },
            lastPaymentColumn: { onCell: getCellLastPayment },
            lastPaymentDateColumn: { onCell: getCellLastPaymentDate },
            balanceDueColumn: { onCell: getCellBalanceDue },
            billingViewColumn: {
                onCell: getCellBillingDetail
            }
        };
    }, [billingDetailsData]);

    const generateClaimDetailsOverrides = useCallback(() => {
        return {
            productColumn: { onCell: getCellProduct },
            policyNumberClaimColumn: { onCell: getCellClaimPolicyNumber },
            claimNumberColumn: { onCell: getCellClaimNumber },
            dateOfLossColumn: { onCell: getCellDateOfLoss },
            statusColumn: { onCell: getCellClaimStatus },
            claimDetailViewColumn: {
                onCell: getCellClaimDetail
            }
        };
    }, [claimDataTable]);

    const onFileAClaimQuickLinkClick = useCallback(
        () => () => {
            const { history } = props;
            return history.push({
                pathname: '/fnol-select-policy',
                state: {
                    redirectPath: '/home',
                    claimData: { lossDate: new Date() }
                }
            });
        },
        [props]
    );

    const onFileAClaimButtonClick = useCallback(
        () => {
            const { history } = props;
            return history.push({
                pathname: '/fnol-select-policy',
                state: {
                    redirectPath: '/home',
                    claimData: { lossDate: new Date() }
                }
            });
        },
        [props]
    );


    const handleLinkClick = useCallback(
        (event) => {
            const { history } = props;
            return history.push(event.path);
        },
        [props]
    );

    const showBillingSection = useMemo(() => {
        return isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'billing' });
    }, []);

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }
    const override = {
        '@field': {
            phone: {
                labelPosition: 'left'
            }
        },
        myBalanceOverdueAmount: {
            visible: !_.isEmpty(getMyBalanceOverDueAndCurrentData('due'))
        },
        myBalanceCurrentAmount: {
            visible: !_.isEmpty(getMyBalanceOverDueAndCurrentData('billed'))
        },
        dueDateContainer: {
            visible: !_.isEmpty(getMyBalanceOverDueAndCurrentData('due'))
        },
        dueDateLabel: {
            visible: !_.isEmpty(getMyBalanceOverDueAndCurrentData('billed'))
        },
        payNowButton: {
            visible: firstAccountSummaryDefined
        },
        mediaSidebar: {
            showContact: accountData.length > 1
        },
        policiesTable: {
            data: accountPolicyData
        },
        billingTable: {
            data: billingDetailsData
        },
        billingEmpty: {
            visible: _.isEmpty(billingDetailsData)
        },
        printAnIDCardLink: {
            visible: !_.isNil(policyWithIDCard),
            href: getIDCardQuickLink,
            target: '_blank'
        },
        setupAutomatedPaymentsLink: {
            to: automatedPaymentURL,
            visible: !!automatedPaymentURL && showBillingSection
        },
        getAPAQuote: {
            onClick: onQuoteQuickLinkClick('PersonalAuto'),
            visible: appConfig.quoteAndBuy.ampQuote && firstAccountSummaryDefined
        },
        getAHOQuote: {
            onClick: onQuoteQuickLinkClick('Homeowners'),
            visible: appConfig.quoteAndBuy.ampQuote && firstAccountSummaryDefined
        },
        renewalNotification: {
            visible: shouldRenewalNotificationShow(accountPolicyData)
        },
        fileAClaimLink: {
            onClick: onFileAClaimQuickLinkClick(),
            visible: claimCapabilityCheck
        },
        tileGroupContainer: {
            visible: showBillingSection
        },
        makeAPaymentLink: {
            visible: showBillingSection
        },
        agentCompany: {
            content: 'ABC Insurance Brokers Ltd'
        },
        agentName: {
            content: 'MARTHA STEWART, CIP'
        },
        agentAddressLine1: {
            content: '123 Main Street, Ajax, ON, JSM 509'
        },
        agentPhone: {
            content: 'Phone: 905-352-6784'
        },
        agentEmail: {
            content: 'Email: martha.stewart@insurance.com'
        },
        contactUsCompany: {
            content: 'Trillium Mutual'
            // content: 'EY Canada'
        },
        contactUsCompanyLine1: {
            content: 'Insurance Company'
        },
        contactUsAddressLine1: {
            content: '495 Mitchell Road South, Listowel,'
            // content: '100 Adelaide St W, Toronto, ON M5H 0B3'
        },
        contactUsAddressLine2: {
            content: 'ON N4W 0C8'
        },
        contactUsPhone: {
            content: 'Phone: (519) 291-9300'
            // content: 'Phone: (416) 864 1234'
        },
        contactUsFax: {
            content: 'Fax: (519) 291-1800'
            // content: 'Fax: (416) 864 1174'
        },
        repeatCard: {
            data: accountPolicyData
        },
        claimsTable: {
            data: claimDataTable
        },
        claimEmpty: {
            visible: _.isEmpty(claimDataTable)
        },
        fileClaimButton: {
            to: onFileAClaimButtonClick
        },
        welcomeId: {
            content: `Welcome ${useAuthentication().given_name}!`
        },
        welcomeGridItem: {
            visible: showGreeting
        },
        ContactUsLogoImage:{
            src: getImageSrc("branding/Trillium_Primary_Logo_RGB.png"),
        },
        ...getTableOverrides(),
        ...generatePolicyCardOverrides(),
        ...generateBillingDetailsOverrides(),
        ...generateClaimDetailsOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveValue: readValue,
        resolveCallbackMap: {
            handleLinkClick,
            onFileAClaimButtonClick
        },
        resolveComponentMap: {
            pagebannercomponent: PageBannerComponent
        }
    };

    return renderContentFromMetadata(metadata.pageContent, override, resolvers);
}

export default withRouter(LandingPage);
